<app-login></app-login>
<div class="container-fluid routerOutlet" [hidden]="loading">
    <router-outlet></router-outlet>
</div>